import { InjectionToken } from '@angular/core';
import { Subject } from 'rxjs';

export const LOGOUT_EVENT = new InjectionToken<Subject<boolean>>('Logout event', {
  providedIn: 'root',
  factory: () => new Subject<boolean>()
});
